import { useQuery } from "react-query";
import { fetchFeatureFlag } from "./fetchFeatureFlag";

const useFeatureFlags = (flag: string) => {
  const { data, isLoading, error } = useQuery(["feature-flag", flag], () => fetchFeatureFlag(flag), {
    retry: true,
    retryDelay: 3000,
  });

  const isEnabled = Boolean(data?.state);

  return { isEnabled, isLoading, error };
};

export { useFeatureFlags };
